import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const DepartmentCell = props => (
  <div className="rt-td--default">
    <span>{_.get(props.value, 'name')}</span>
  </div>
);

DepartmentCell.propTypes = {
  value: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
  }),
};

export default DepartmentCell;
